$(function() {
	$(".update_discount").on("change",function(){
		update_discount(this.id);
	});
});

window.update_discount = function(id) {
		// ppd 			= party_part_discount
		// monthly_d	= monthly_discount

		var pc_spc = id.split("_")						;
		var party_category_id		=	pc_spc[1]		;
		var spare_part_category_id	=	pc_spc[2]		;
		var data					=	{
											"party_category_id"			: 	party_category_id		,
											"spare_part_category_id"	: 	spare_part_category_id	,
										};
		
		var is_party_party_discount = id.includes("ppd")			;	// PARTY PART DISCOUNT
		var is_monthly_discount		= id.includes("monthlyd")		;	// MONTHLY DISCOUNT
		
		if(is_party_party_discount){			
				var path = "/party_part_discounts/" +  "add_update"							;
				data["discount_percent"]	=	document.getElementById(id).value		;
		}
		else if(is_monthly_discount){
				var path = "/monthly_discounts/" +  "add_update"						;
				if(id.includes("percentage"))
					data["discount_percent"]	= 	document.getElementById(id).value	;					
				else if(id.includes("amount"))
					data["discount_amount"]		= 	document.getElementById(id).value	;
		}
		else{
			var path = ""	;
		}
		
				
		$.ajax({	url: path,
					type: "put",
					data: data	,
					dataType: "json", 
					success: function(result){
					}
		});
};
